import { Card, Grid, Typography, Box } from '@medely/web-components';
import { useTheme } from '@medely/web-components/themes';
import React from 'react';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';
import { decodeInviteToken } from 'utils/token';
import AcceptInviteForm from './AcceptInviteForm';

const AcceptInvite = () => {
  const theme = useTheme();
  const [{ token }] = useQueryParams({
    token: withDefault(StringParam, ''),
  });
  const { company_name, email, inviter_first_name, inviter_last_name } = decodeInviteToken(token);

  return (
    <Grid container direction="column" spacing={2} m={-1}>
      <Box px={{ xs: 4, sm: 6, md: 10 }} bgcolor={theme.palette.primary.main}>
        <Grid item xs={12} display="flex" justifyContent="space-between">
          <Grid
            item
            md={7}
            display={{
              xs: 'none',
              sm: 'none',
              md: 'flex',
            }}
            justifyContent="center"
            flexDirection="column"
            rowGap={3}
            mr={6}
          >
            <Typography variant="h4" color="white" weight="medium">
              Join the {company_name} team.
            </Typography>
            <Typography variant="h6" color="white">
              {`You have been invited by ${inviter_first_name} ${inviter_last_name}.`}
            </Typography>
            <Typography variant="h6" color="white">
              To start, accept this invite and sign up using {email}.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={5} display="flex" justifyContent="center">
            <Card
              variant="outlined"
              sx={{
                width: 'clamp(360px, 30rem, 560px)',
                padding: '32px',
                margin: '56px 0',
              }}
            >
              <Typography variant="h5" color="textPrimary" textAlign="center" pb={4}>
                Join Your Team
              </Typography>
              <AcceptInviteForm />
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Box
        px={{ xs: 4, sm: 6, md: 10 }}
        my={3}
        display="flex"
        justifyContent="center"
        columnGap={3}
        textAlign="center"
      >
        <Typography color="gray" variant="caption">
          Powered by Medely
        </Typography>
      </Box>
    </Grid>
  );
};

export default AcceptInvite;
